import { APIClient } from './APIClient'

export const fetchHighwayLines = (language = 'en') => {
    return APIClient.get(`/v1/${language}/highways/lines`)
}
